import { execAdmin } from '@src/apis/reware/utils';

export interface InitiatePricingArgs {
  partnerId: number;
  pricingType: string;
}

interface InitiatePricingExecVariables {
  partnerId: number;
  pricingType: string;
}

interface InitiatePricingExecResponse {
  partner: {
    initiatePricing: string; // Returns the initiatedAt timestamp
  };
}

/**
 * Initiates pricing rule processing for a partner.
 * This starts a background job that applies the pricing rules to catalog items.
 * Returns the timestamp when the job was initiated.
 */
export const initiatePricing = async ({
  partnerId,
  pricingType,
}: InitiatePricingArgs): Promise<string> => {
  const query = `
    mutation initiatePricing(
      $partnerId: Int!
      $pricingType: String!
    ) {
      partner(id: $partnerId) {
        initiatePricing(pricingType: $pricingType)
      }
    }
  `;

  const data = await execAdmin<InitiatePricingExecVariables, InitiatePricingExecResponse>(
    query,
    { variables: { partnerId, pricingType } }
  );

  const result = data.partner?.initiatePricing;
  if (!result) {
    throw new Error(
      `initiatePricing: unexpected response — partner.initiatePricing is ${result === null ? 'null' : 'undefined'} (partnerId=${partnerId}, pricingType=${pricingType})`
    );
  }

  return result;
};
